// Single app-wide context: App.jsx builds one value from all of its state, setters, handlers and computed values
// (mirroring the original single-scope component); screen/section components read what they need via useApp().
import { createContext, useContext } from 'react';

export const AppContext = createContext(null);

export function useApp() {
    return useContext(AppContext);
}
